import React from "react";
import { Provider } from "react-redux";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ShoppingCartProvider } from "./components/_default/context/ShoppingCartContext"
import store from "./store/store"
import Redirect from "./components/_default/utilities/Redirect"
import TagManager from 'react-gtm-module'
// Pages
import Webpage1Avaleht from "./pages/Webpage1Avaleht";

var baseURL = 'https://helenimaja.kassahaldus.ee/webstoreApi';
var axiosHeaders = {
    Authorization: 'Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.eyJhdWQiOiI0IiwianRpIjoiNWY1OTU0ZTZhMGJiZDNjMWM1NzJkMjE5NjkxMjI5NmE5ZTFmZDA2MGJhZDQ3YzkxYjUzNGM2MzcyZTVhMmRlMDA0ZTdhYmQ4MDZmMDg0NWUiLCJpYXQiOjE3NDQwMjc1OTEuNzkwMjk0LCJuYmYiOjE3NDQwMjc1OTEuNzkwMywiZXhwIjoxNzQ0MTEzOTkxLjc4NTE2Nywic3ViIjoiNjYiLCJzY29wZXMiOltdfQ.fboMtyxh5lbtWvMYDcQp-OcZnCenXdicJSMjTHiP7ksE6O43TQ_mAVTJ-5c14zGZlXFle_krhOjYMB1G_aRh6SjGEL4ZoIewWrd21M0fqDJwA2o9mBJ1eJRM9iAuy5IcX93pyt7eocE0uwkcxfWjYPPGl5KUiEnpuYpOHon247oAPvDT6xZQbFij-2ASXXsYh_i-HtezMEyL5kXr3REh8zLA4tjmAB3srmsaRwLcr9XSeGkztVG1A0v_rwHplavYfUbHhClYLQf9XprfWsuJs440Uh3OmEGob_AYa88dPqB194cIR0kXu1t2-jUR21QlEDzWXTmDxl3Pvv6sSbieIYu1QZMwZQu1Vi0oTGhY7J3-Oj1QgTZGkMoV1fW_OZr2hTAH8MJmx9bT-3tYCeIyi0ebEvUfy3oVr4rxVOqXtpiHiZybwBLOilejLf7dcLhwmpe1EwxGIucJ4fy-WQ5uOn51xxW8HVr9RAko7iBlSjxbNL_-EORHHaqiJjIvRWxnAbsqH3LIk8Ftk4Xze_i2wqpNpCiORi4tqFHhWd7oUylfU8pcKISKIxW3gYDMYxcag72xkqZhX7nLV_0if949sTpaxZ0UoTylzcce-815998XuEoOf316doiU77cY_02fq50X0pyYu6WBM3YXTcoTWeI2R8jQaXxupKCQ---ghkc',
    'Access-api-key': "eyJpdiI6Ik1OOVo3SmI2djl0T1IyU0FPRzNqc2c9PSIsInZhbHVlIjoidlUyYmhiMUVvS2JPZ3FsM2htQmlMQT09IiwibWFjIjoiMjIwYWMyYmE0ZGVjNTA1ZTQzYzgxYTQxNjJkMjM4NTFjZDBmNTQyZDY2OWQxMzk2YmRkOGMzNjJhOTdiMjMzNCIsInRhZyI6IiJ9",
    'Access-api-id': "eyJpdiI6IjdaazViUG1xRzZ6ck9nc3pPRVBEQkE9PSIsInZhbHVlIjoiaDRtWDJUbXNGQkNQOGFWTi8rS01Ldz09IiwibWFjIjoiNmYzNDAzZTQ0Y2Q1MjQwZTNjNDM0ZThkMDVkZjM5YTYxODg0M2I1NmUyYTllM2MwNDA3ODc2MmIyYTQ0NzYzNCIsInRhZyI6IiJ9",
    'Access-Control-Allow-Origin': "*"
 };


window.axios = require('axios').create({
  baseURL: baseURL,
  headers: axiosHeaders
});
const tagManagerArgs = {
    gtmId: ""
}
TagManager.initialize(tagManagerArgs)
    
export default function App() {
    window.dataLayer.push({
        event: 'pageview'
    });
    return (
        <Provider store={store}>
            <ShoppingCartProvider>
                <BrowserRouter basename="/">
                    <Routes>
                                            <Route path="/et/" element={<Webpage1Avaleht />} exact />;
                                                                
                                                                <Route path="*" element={<Webpage1Avaleht />} exact />;
                                        </Routes>
                </BrowserRouter>
            </ShoppingCartProvider>
        </Provider>
    );
}